export function Continue({
  width = 24,
  height = 24,
  className = '',
}: {
  width?: number;
  height?: number;
  className?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.75 6C18.75 5.80109 18.671 5.61032 18.5303 5.46967C18.3897 5.32902 18.1989 5.25 18 5.25C17.8011 5.25 17.6103 5.32902 17.4697 5.46967C17.329 5.61032 17.25 5.80109 17.25 6V10.872L7.8495 5.418C7.0395 4.95 6 5.517 6 6.462V17.538C6 18.483 7.038 19.053 7.8495 18.5835L17.25 13.1295V18C17.25 18.1989 17.329 18.3897 17.4697 18.5303C17.6103 18.671 17.8011 18.75 18 18.75C18.1989 18.75 18.3897 18.671 18.5303 18.5303C18.671 18.3897 18.75 18.1989 18.75 18V6Z"
        fill="white"
      />
    </svg>
  );
}

export default Continue;
